import { useCallback } from "react";
import { InspectionInfo } from "../../models/workorders/Inspection";
import { saveInspection } from "../../models/inspections/Inspections";
import { removeInspectionFromLocal } from "../../util/InspectionsHelper";
// import { useWorkOrderStore } from "../../store/wo-order";
// import { useEquipmentStore } from "../../store/equipment";

export default function useCompleteInspection() {
  // const completeWoInspection = useWorkOrderStore(
  //   (state) => state.markInspectionCompleted
  // );
  // const completeEquipInspection = useEquipmentStore(
  //   (state) => state.markInspectionCompleted
  // );

  const completeInspection = useCallback(async (inspection: InspectionInfo) => {
    const {
      checkOverride,
      comments,
      currentTestEquip,
      inspectionDefinition,
      inspectionId,
      pointVals,
      woNumber,
      pointImages,
      pointComments,
      equipmentId,
      isEquipmentContext,
    } = inspection;
    const response = await saveInspection(
      woNumber,
      inspectionId,
      pointVals,
      inspectionDefinition,
      checkOverride,
      comments,
      currentTestEquip,
      pointImages,
      pointComments,
      equipmentId,
      isEquipmentContext
    );
    if (!response.isError) {
      // Remove inspection from local storage if present
      await removeInspectionFromLocal(inspectionId, woNumber, equipmentId);
      //mark the inspection complete in the offline store
      // if (isEquipmentContext && equipmentId)
      //   completeEquipInspection(equipmentId, inspectionId);
      // else if (!isEquipmentContext && woNumber)
      //   completeWoInspection(woNumber, inspectionId);
    }
    return response;
  }, []);

  return { completeInspection };
}
